export default __webpack_public_path__ + "static/kathi_totale-a3263f7734fc3038b40997a25ee93535.png";